import React, { useState, useRef, useMemo } from 'react';
import { useTable, useSortBy } from 'react-table';
import { Table } from 'react-bootstrap';
import Select from 'react-select';
import TerritorySelect from '../../../../components/navbar/TerritorySelect';
import { hideLoading, showLoading } from '../../../../lib/uiService';
import AdminService from '../../../../services/admin.service';
import TableHead from '../../../../components/common/TableHead';

const selectionStyle = {
  container: (baseStyles) => ({
    ...baseStyles,
    width: '180px',
  }),
  control: (baseStyles) => ({
    ...baseStyles,
    minHeight: '27px',
    borderColor: 'rgb(118, 118, 118)',
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    height: '27px',
    alignItems: 'normal',
  }),
  indicatorsContainer: (baseStyles) => ({
    ...baseStyles,
    height: '27px',
  }),
};

const inputStyle = {
  width: '60px',
};

const renderCurrentValue = (item: any, field: string) => {
  const value = item?.product?.product?.productPrices[0][field];
  return (
    <div className="text-small" style={{ fontSize: '12px', color: 'rgb(118, 118, 118)' }}>
      {value || '-'}
    </div>
  );
};

const comparePriceField = (itemA: any, itemB: any, field: string) => {
  const valueA = itemA?.[field];
  const valueB = itemB?.[field];
  console.log('compare', field, valueA, valueB);
  if (valueA === null && valueB === null) {
    return true;
  }
  if (valueA == valueB) {
    return true;
  }
  if (Number(valueA) === Number(valueB)) {
    return true;
  }
  return false;
};

const ProductStatesFobs = ({
  productHasHistory,
  products,
  statePrices,
  setStatePrices,
  deletedTerritoryPrices,
  setDeletedTerritoryPrices,
  createdTerritoryPrices,
  setCreatedTerritoryPrices,
  editedTerritoryPrices,
  setEditedTerritoryPrices,
  natlPrice,
}: {
  productHasHistory: boolean;
  territories: any;
  products: any;
  brandFamilies?: any;
  brands?: any;
  statePrices: any;
  natlPrice: any;
  setStatePrices: (x: any) => void;
  deletedTerritoryPrices: any;
  setDeletedTerritoryPrices: (x: any) => void;
  createdTerritoryPrices: any;
  setCreatedTerritoryPrices: (x: any) => void;
  editedTerritoryPrices: any;
  setEditedTerritoryPrices: (x: any) => void;
}) => {
  const [initialTerritoryPrices, setInitialTerritoryPrices] = useState<any>([]);
  const scrollableRef: any = useRef(null);
  const dataRef = useRef<any>({
    statePrices,
    editedTerritoryPrices,
    initialTerritoryPrices,
  });
  Object.assign(dataRef.current, {
    statePrices,
    editedTerritoryPrices,
    initialTerritoryPrices,
  });

  const checkAndSetEditedTerritoryPrices = (updatedEditedChanges) => {
    const { initialTerritoryPrices } = dataRef.current;
    const filteredInitialPrices = updatedEditedChanges.filter((item: any) => {
      const isInitValue = initialTerritoryPrices.find((existingItem: any) => {
        return (
          existingItem.productPriceId === item.productPriceId &&
          [
            'price',
            'tier1Price',
            'tier2Price',
            'distributorId',
            'onPremisePrice',
            'offPremisePrice',
            'caseOnePrice',
          ].every((field) => {
            const isEqual = comparePriceField(existingItem, item, field);
            return isEqual;
          })
        );
      });
      return !isInitValue;
    });
    setEditedTerritoryPrices(filteredInitialPrices);
  };

  const handleFieldChange = (productPriceId: string, newValue: string, wasCreated: boolean, field: string) => {
    const { editedTerritoryPrices, statePrices, initialTerritoryPrices } = dataRef.current;
    const existingChange = statePrices.find((change: any) => change.productPriceId === productPriceId);

    if (existingChange) {
      // Update the statePrices array
      const updatedChanges = statePrices.map((change: any) =>
        change.productPriceId === productPriceId ? { ...change, [field]: newValue } : change,
      );
      setStatePrices(updatedChanges);

      if (wasCreated) {
        const existingChangeCreatedData = createdTerritoryPrices.find(
          (change: any) => change.productPriceId === productPriceId,
        );

        if (existingChangeCreatedData) {
          const updatedCreatedChanges = createdTerritoryPrices.map((change: any) =>
            change.productPriceId === productPriceId ? { ...change, [field]: newValue } : change,
          );
          setCreatedTerritoryPrices(updatedCreatedChanges);
        } else {
          setCreatedTerritoryPrices([...createdTerritoryPrices, { ...existingChange, [field]: newValue }]);
        }

        const filteredDeletedPrices = deletedTerritoryPrices.filter(
          (item1) => !createdTerritoryPrices.some((item2) => item1.productPriceId === item2.productPriceId),
        );
        setDeletedTerritoryPrices(filteredDeletedPrices);
      } else {
        const existingChangeEditedData = editedTerritoryPrices.find(
          (change: any) => change.productPriceId === productPriceId,
        );

        if (existingChangeEditedData) {
          const updatedEditedChanges = editedTerritoryPrices.map((change: any) =>
            change.productPriceId === productPriceId ? { ...change, [field]: newValue } : change,
          );
          checkAndSetEditedTerritoryPrices(updatedEditedChanges);
        } else {
          setInitialTerritoryPrices([...initialTerritoryPrices, { ...existingChange }]);
          const updatedEditedChanges = [...editedTerritoryPrices, { ...existingChange, [field]: newValue }];
          checkAndSetEditedTerritoryPrices(updatedEditedChanges);
        }
      }
    } else {
      setStatePrices([...statePrices, { productPriceId, [field]: newValue }]);
    }
  };

  const applyAllPrices = () => {
    const newPrices = statePrices.map((item) => ({ ...item, price: natlPrice }));
    setStatePrices(newPrices);
    setEditedTerritoryPrices(newPrices);
  };

  const [selectedBrand, setSelectedBrand] = useState<any>(null);
  const [selectedBrandFamily, setSelectedBrandFamily] = useState<any>(null);
  const [selectedFormat, setSelectedFormat] = useState<any>(null);

  const setProductData = async (rowData: any) => {
    showLoading();
    AdminService.ListProductPricesByTerritory(rowData.territoryId)
      .then(({ data }) => {
        setStatePrices(data.sort((a: any, b: any) => a.name.localeCompare(b.name)));
        hideLoading();
      })
      .catch((error) => {
        console.log(error);
        hideLoading();
      });
  };

  const productsMap = React.useMemo(() => {
    const options = {};
    products.map((item) => {
      options[`${item.productId}`] = {
        value: item.productId,
        label: `${item.name} (${item.shortName})`,
        shortName: item.shortName,
        description: item.description,
        brandId: item.brandId,
        brand: item.brand,
        brandFamilyId: item.brandFamilyId,
        brandFamily: item.brandFamily,
        volume: item.volume,
      };
    });
    return options;
  }, [products]);

  const brandOptions = React.useMemo(() => {
    const options = {};
    products.map((item) => {
      options[`${item.brandId}`] = {
        value: item.brandId,
        label: item.brand,
      };
    });
    return Object.values(options);
  }, [products]);
  const brandFamilyOptions = React.useMemo(() => {
    const options = {};
    products.map((item) => {
      if (selectedBrand && item.brandId === selectedBrand) {
        options[`${item.brandFamilyId}`] = {
          value: item.brandFamilyId,
          label: item.brandFamily,
        };
      }
    });
    return Object.values(options);
  }, [products, selectedBrand]);

  const formatOptions = React.useMemo(() => {
    const options = {};
    products.map((item) => {
      let { volume } = item;
      volume = Number(volume);
      if (volume) {
        options[`${volume}`] = {
          value: volume,
          label: volume >= 1000 ? `${volume / 1000} L` : `${volume} ml`,
        };
      }
    });
    return [{ value: '', label: 'All' }, ...Object.values(options)];
  }, [products]);

  const territoryId = localStorage.getItem('Territory');
  React.useEffect(() => {
    setProductData({ territoryId });
  }, [territoryId]);

  const statePricesFiltered = React.useMemo(() => {
    return statePrices.filter((item: any) => {
      if (productHasHistory) {
        return true;
      }
      const product = productsMap[item.productId];
      if (
        editedTerritoryPrices.some(
          (editedItem: any) =>
            editedItem.productPriceId === item.productPriceId && editedItem.territoryId === item.territoryId,
        )
      ) {
        return true;
      }
      if (selectedBrand && product?.brandId !== selectedBrand) {
        return false;
      }
      if (selectedBrandFamily && product?.brandFamilyId !== selectedBrandFamily) {
        return false;
      }
      if (selectedFormat && Number(product?.volume) !== Number(selectedFormat)) {
        return false;
      }
      return true;
    });
  }, [statePrices, selectedBrand, selectedBrandFamily, selectedFormat, productHasHistory, editedTerritoryPrices]);

  const columns: any = useMemo(
    () => [
      {
        Header: 'State',
        accessor: 'territory.shortName',
        Cell: ({ value }: { value: any }) => value?.toUpperCase() || '',
        disableSortBy: true,
      },
      {
        Header: 'Brand',
        accessor: (row: any) => productsMap[row.productId]?.brand || '',
        Cell: ({ value }: { value: any }) => value,
        disableSortBy: false,
      },
      {
        Header: 'Brand Family',
        accessor: (row: any) => productsMap[row.productId]?.brandFamily || '',
        Cell: ({ value }: { value: any }) => value,
        disableSortBy: false,
      },
      {
        Header: 'Product',
        accessor: (row: any) => productsMap[row.productId]?.description || '',
        Cell: ({ value }: { value: any }) => value,
        disableSortBy: false,
      },
      {
        Header: 'FOB',
        accessor: 'price',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;
          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.price}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^-?\d*\.?\d*$/.test(inputValue) || inputValue === '-' || inputValue === '') {
                    handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'price');
                  } else {
                    e.preventDefault();
                  }
                }}
                style={inputStyle}
              />
              {productHasHistory && renderCurrentValue(terr, 'price')}
              {Number(terr.price) <= 0 && <p className="text-danger">Price must be greater than 0</p>}
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: 'Tier 1',
        accessor: 'tier1Price',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;

          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.tier1Price}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^-?\d*\.?\d*$/.test(inputValue) || inputValue === '-' || inputValue === '') {
                    handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'tier1Price');
                  } else {
                    e.preventDefault();
                  }
                }}
                style={inputStyle}
              />
              {productHasHistory && renderCurrentValue(terr, 'tier1Price')}
              {terr.tier1Price !== null && terr.tier1Price !== '' && Number(terr.tier1Price) <= 0 && (
                <p className="text-danger">Tier 1 must be greater than 0</p>
              )}
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: 'Tier 2',
        accessor: 'tier2Price',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;

          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.tier2Price}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^-?\d*\.?\d*$/.test(inputValue) || inputValue === '-' || inputValue === '') {
                    handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'tier2Price');
                  } else {
                    e.preventDefault();
                  }
                }}
                style={inputStyle}
              />
              {productHasHistory && renderCurrentValue(terr, 'tier2Price')}
              {terr.tier2Price !== null && terr.tier2Price !== '' && Number(terr.tier2Price) <= 0 && (
                <p className="text-danger">Tier 2 must be greater than 0</p>
              )}
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: 'DistributorId',
        accessor: 'distributorId',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;

          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.distributorId}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'distributorId');
                }}
                style={{ width: '100px' }}
              />
              {productHasHistory && renderCurrentValue(terr, 'distributorId')}
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: 'On-Premise Price',
        accessor: 'onPremisePrice',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;

          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.onPremisePrice}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^-?\d*\.?\d*$/.test(inputValue) || inputValue === '-' || inputValue === '') {
                    handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'onPremisePrice');
                  } else {
                    e.preventDefault();
                  }
                }}
                style={inputStyle}
              />
              {productHasHistory && renderCurrentValue(terr, 'onPremisePrice')}
              {terr.onPremisePrice !== null && terr.onPremisePrice !== '' && Number(terr.onPremisePrice) <= 0 && (
                <p className="text-danger">On-Premise must be greater than 0</p>
              )}
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: 'Off-Premise Price',
        accessor: 'offPremisePrice',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;

          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.offPremisePrice}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^-?\d*\.?\d*$/.test(inputValue) || inputValue === '-' || inputValue === '') {
                    handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'offPremisePrice');
                  } else {
                    e.preventDefault();
                  }
                }}
                style={inputStyle}
              />
              {productHasHistory && renderCurrentValue(terr, 'offPremisePrice')}
              {terr.offPremisePrice !== null && terr.offPremisePrice !== '' && Number(terr.offPremisePrice) <= 0 && (
                <p className="text-danger">Off-Premise must be greater than 0</p>
              )}
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: 'Case One Price',
        accessor: 'caseOnePrice',
        Cell: ({ data, row }: { data: any; row: any }) => {
          const terr = data[row.id];
          const product = productsMap[terr.productId];
          if (!product) return null;

          return (
            <div className="text-center">
              <input
                type="text"
                value={terr.caseOnePrice}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^-?\d*\.?\d*$/.test(inputValue) || inputValue === '-' || inputValue === '') {
                    handleFieldChange(terr.productPriceId, inputValue, terr.wasCreated, 'caseOnePrice');
                  } else {
                    e.preventDefault();
                  }
                }}
                style={inputStyle}
              />
              {productHasHistory && renderCurrentValue(terr, 'caseOnePrice')}
              {terr.caseOnePrice !== null && terr.caseOnePrice !== '' && Number(terr.caseOnePrice) <= 0 && (
                <p className="text-danger">Case One must be greater than 0</p>
              )}
            </div>
          );
        },
        disableSortBy: true,
      },
    ],
    [productsMap, productHasHistory],
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: statePricesFiltered,
      initialState: {
        sortBy: [
          {
            id: 'Brand',
            desc: false,
          },
          {
            id: 'Brand Family',
            desc: false,
          },
        ],
      },
    },
    useSortBy,
  );

  const isRowDirty = (item: any) => {
    return editedTerritoryPrices.some((editedItem: any) => editedItem.productPriceId === item.productPriceId);
  };

  return (
    <div className="col ps-4">
      <div>
        {!productHasHistory && (
          <div className="d-flex justify-content-between">
            <div className="my-2 d-flex">
              <div className="mx-2">
                <TerritorySelect placeholder="State/Region" />
              </div>
              <div className="mx-2">
                <Select
                  placeholder="Brand"
                  isSearchable={true}
                  defaultInputValue=""
                  value={brandOptions.find((option: any) => option?.value === selectedBrand) || null}
                  onChange={(option: any) => {
                    setSelectedBrand(option?.value);
                    setSelectedBrandFamily(null);
                  }}
                  options={brandOptions}
                  styles={selectionStyle}
                />
              </div>
              <div className="mx-2">
                <Select
                  placeholder="Brand Family"
                  isSearchable={true}
                  defaultInputValue=""
                  value={brandFamilyOptions.find((option: any) => option?.value === selectedBrandFamily) || null}
                  onChange={(option: any) => {
                    setSelectedBrandFamily(option?.value);
                  }}
                  options={brandFamilyOptions}
                  styles={selectionStyle}
                />
              </div>
              <div className="mx-2">
                <Select
                  placeholder="Format"
                  isSearchable={true}
                  defaultInputValue=""
                  value={formatOptions.find((option: any) => option?.value === selectedFormat) || null}
                  onChange={(option: any) => {
                    setSelectedFormat(option?.value);
                  }}
                  options={formatOptions}
                  styles={selectionStyle}
                />
              </div>
            </div>
          </div>
        )}
        <div className="table-responsive table-sm" ref={scrollableRef} style={{ fontSize: '11px' }}>
          <Table striped className="table-sm" bordered {...getTableProps()} style={{ fontSize: '13px' }}>
            <TableHead isSticky headerGroups={headerGroups} />
            <tbody {...getTableBodyProps()} style={{ borderTop: '2px solid #6c757d' }}>
              {statePricesFiltered?.length === 0 ? (
                <tr>
                  <td colSpan={columns.length}>
                    <p>No new State Prices. Add one above</p>
                  </td>
                </tr>
              ) : (
                rows.map((row, index) => {
                  const item: any = row.original;
                  const product = productsMap[item?.productId];
                  if (!product) return null;

                  const isDirty = isRowDirty(item);
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      key={index}
                      style={{
                        backgroundColor: isDirty ? '#fff3cd' : 'transparent',
                        borderLeft: isDirty ? '4px solid #ffc107' : 'none',
                      }}
                      className={isDirty ? 'table-warning' : ''}
                    >
                      {row.cells.map((cell, cellIndex) => (
                        <td {...cell.getCellProps()} key={cellIndex}>
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default ProductStatesFobs;
